module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image3_dochimom-6048689d089035098065ffc6f0e8b7b7.png";